import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/gft.scss' // gft css
import '@/assets/styles/upload.scss' // upload css
// import '@/assets/styles/index_change.css'
import App from './App'
import store from './store'
import router from './router'
import permission from './directive/permission'
import preventClick from './directive/clickState/preventReClick'
import { download,downloadGetMethod,exportData} from '@/utils/request'
import {isStrEmpty,praseStrEmpty,dragControllerDiv} from "@/utils/gft"
import i18n from './i18n'

import './assets/icons' // icon
import './permission' // permission control
import { getDicts } from "@/api/system/dict/data";
import { getConfigKey } from "@/api/system/config";
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree, showChatFormByUserId} from "@/utils/gft";
import Pagination from "@/components/Pagination";

import { routerLink } from "@/utils/gft";
import { listDatasFormatter } from "@/utils/gft";
import { listDateFormatter } from "@/utils/gft";
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import { initAesKeys } from "@/utils/aes";

//自定义表格工具扩展
import RightToolbar from "@/components/RightToolbar"
// import xiala from "@/components/xiala"
// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.showChatFormByUserId = showChatFormByUserId
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.downloadGetMethod = downloadGetMethod
Vue.prototype.exportData = exportData
Vue.prototype.handleTree = handleTree
Vue.prototype.routerLink = routerLink
Vue.prototype.listDatasFormatter = listDatasFormatter
Vue.prototype.listDateFormatter = listDateFormatter
Vue.prototype.isStrEmpty = isStrEmpty
Vue.prototype.praseStrEmpty = praseStrEmpty
Vue.prototype.dragControllerDiv = dragControllerDiv

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}
Vue.prototype.msgAlert = function (titleName,content){
  this.$alert(content, titleName, {
    confirmButtonText: '确定',
    callback: action => {
      // this.$message({
      //   type: 'info',
      //   message: `action: ${ action }`
      // });
    }
  });
}

//格式化数字, scale-精确到小数点后几位, flag-是否设置千分符
Vue.prototype.$moneyFormater = function(val, scale, flag){
  if(null == val || undefined == val){
    return '';
  }
  //默认显示2位
  if(null == scale || undefined == scale || '' == scale){
    scale = 2;
  }
  val = val.toString().replace(/\$|\,/g,'');
  if(isNaN(val)) {
    val = "0";
  }
  var scaleValue = 1;
  for (let i = 1; i <= scale; i++) {
    scaleValue = scaleValue * 10;
  }
  let sign = (val == (val = Math.abs(val)));
  val = Math.floor(val*scaleValue+0.50000000001);
  let cents = val%scaleValue;
  val = Math.floor(val/scaleValue).toString();
  if(cents<10) {
     cents = cents + "0"
  }
  //设置千分符
  if(flag){
    for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
        val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
    }
  }
  return (((sign)?'':'-') + val + '.' + cents);
}
initAesKeys();
// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
// Vue.component('xiala', xiala)

Vue.use(permission)
Vue.use(preventClick)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

//金额过滤器，保留两位小数
// Vue.filter('money', function(val) {
//     if(null == val || undefined == val){
//       return '';
//     }
//     val = val.toString().replace(/\$|\,/g,'');
//     if(isNaN(val)) {
//       val = "0";
//     }
//     let sign = (val == (val = Math.abs(val)));
//     val = Math.floor(val*100+0.50000000001);
//     let cents = val%100;
//     val = Math.floor(val/100).toString();
//     if(cents<10) {
//        cents = "0" + cents
//     }
//     for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
//         val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
//     }
//     return (((sign)?'':'-') + val + '.' + cents);
// })

// 全局引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
